import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface SuccessProps {
  mainColor?: string;
  secondaryColor?: string;
  style?: React.CSSProperties;
}

export const SuccessIcon = ({
  mainColor = RoutalPalette.success.medium,
  secondaryColor = RoutalPalette.neutral02n,
  style = {},
  ...props
}: SuccessProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 21 21" fill="none" style={{ width: `21px`, height: `21px`, ...style }}>
      <g clipPath="url(#clip0_296_33011)">
        <circle cx="10.1748" cy="10.197" r="10" fill={mainColor} />
        <path
          d="M6.06104 11.4628L7.95968 13.3614L14.2885 7.03259"
          fill="transparent"
          stroke={secondaryColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_296_33011">
          <rect width="20" height="20" fill={secondaryColor} transform="translate(0.174805 0.197021)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
